import { render } from "./MeusAtalhosMobile.vue?vue&type=template&id=20d2bc50&ts=true"
import script from "./MeusAtalhosMobile.vue?vue&type=script&lang=ts"
export * from "./MeusAtalhosMobile.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__